import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Downbar from './Downbar';
import Sidebar from './Sidebar';
import ProfileModal from './ProfileModal';
import AccountHistoryModal from './AccountHistoryModal';
import GameHistoryModal from './GameHistoryModal';
import CountryBlockedPage from './CountryBlockedPage';
import ReactDOM from 'react-dom';
import { usePayment } from '../context/PaymentContext';
import { useGeo } from '../context/GeoContext';
import '../styles/global.css';

const Layout = ({ children }) => {
  const [sidebarMode, setSidebarMode] = useState('full'); // 'full' | 'icons'
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  // Получаем данные о геоблокировке из контекста
  const { isBlocked, userIp, userCountry, userCountryName } = useGeo();

  const {
    showProfileModal: paymentShowProfileModal,
    closeProfileModal,
    showAccountHistoryModal,
    closeAccountHistoryModal,
    showGameHistoryModal,
    closeGameHistoryModal
  } = usePayment();

  // Определяем страницы где нужно скрыть Downbar
  const hideDownbar = location.pathname.startsWith('/gis-game/') || location.pathname.startsWith('/game/');

  // Определяем нужно ли скрыть Header (только на мобильных устройствах на страницах игр)
  const hideHeaderOnMobile = isMobile && (location.pathname.startsWith('/gis-game/') || location.pathname.startsWith('/game/'));


  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Если страна заблокирована - показываем страницу блокировки
  if (isBlocked) {
    return (
      <CountryBlockedPage
        userIp={userIp}
        userCountry={userCountry}
        userCountryName={userCountryName}
      />
    );
  }

  // Определяем класс контейнера
  const containerClass = `container ${!isMobile ? (sidebarMode === 'full' ? 'sidebar-open' : 'sidebar-icons') : ''}`;

  return (
    <div className={containerClass}>
      <div className="site-content">
        {!hideHeaderOnMobile && <Header />}
        <main>{children}</main>
        {!hideDownbar && <Footer />}

      </div>
      {!isMobile && (
        <Sidebar
          isOpen={true}
          onClose={() => setSidebarMode('icons')}
          sidebarMode={sidebarMode}
          setSidebarMode={setSidebarMode}
        />
      )}
      {isMobile && (
        <Sidebar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          sidebarMode={'full'}
          setSidebarMode={() => { }}
        />
      )}
      {!hideDownbar && <Downbar onMenuClick={() => setIsSidebarOpen((prev) => !prev)} />}

      {/* Модальные окна */}
      {paymentShowProfileModal && ReactDOM.createPortal(
        <ProfileModal onClose={closeProfileModal} />, document.body
      )}
      {showAccountHistoryModal && ReactDOM.createPortal(
        <AccountHistoryModal onClose={closeAccountHistoryModal} />, document.body
      )}
      {showGameHistoryModal && ReactDOM.createPortal(
        <GameHistoryModal onClose={closeGameHistoryModal} />, document.body
      )}
    </div>
  );
};

export default Layout;
